import * as React from "react";
const SvgArrowDown = props => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129" {...props}><path d="M40.4 121.3c-.8.8-1.8 1.2-2.9 1.2-1.1 0-2.1-.4-2.9-1.2-1.6-1.6-1.6-4.2 0-5.8l51-51-51-51c-1.6-1.6-1.6-4.2 0-5.8 1.6-1.6 4.2-1.6 5.8 0l53.9 53.9c1.6 1.6 1.6 4.2 0 5.8l-53.9 53.9z" style={{
    fill: "#989aae"
  }} transform="rotate(90 64.45 64.5)" /></svg>;
export { SvgArrowDown as ReactComponent };
export default __webpack_public_path__ + "assets/svg/arrow-downtgBMahSMcyh0yQ8k.svg";